import React from 'react'
import PimaryInputSelect from '../../../../../components/forms/pimaryInputSelect'

const Colors = ({colors,colorsFilter,setColors}) => {
    const addColor = (e)=>{
      let intrustsArray = [];
      for (let index = 0; index < colors.length; index++) {
        const element = colors[index];
        intrustsArray.push(element);
      }
      intrustsArray.push(e);
      setColors(intrustsArray);
    }
    const removeColor = (e) =>{
        let newcolor = colors
      var intrustsArray =[];
      intrustsArray = newcolor.filter((item)=> {
        return item.value !== e.value
      })
      setColors(intrustsArray);
    }
  return (
    <>
        <label style={{
            fontSize:"12px"
        }}>Colors</label>
        <PimaryInputSelect setValue={addColor} Options={colorsFilter}/>
        <div className='register_intrustlist_container'>
        { 
            colors.map((item,index)=>{
                return(
                <div className='register_intrustlist_item' key={index} style={{
                    backgroundColor:item.code
                }}>
                    <div className='register_intrustlist_item_name'>
                    <p>{item.name}</p>
                    </div>
                    <div className='register_intrustlist_item_remove' onClick={()=>{removeColor(item)}}>X</div>
                </div>
                )
            })
        }
        </div>
    </>
  )
}

export default Colors
